// extracted by mini-css-extract-plugin
export var borderRadius = "_fv-4";
export var large = "_fv-3";
export var logoContainer = "_fv-0";
export var nameLogo = "_fv-2";
export var small = "_fv-1";